<template>
  <div>
    <gallery :images="images" :post="post"/>
  </div>
</template>

<script>
  import Gallery from '@/components/partials/Gallery'

  export default {
    name: 'image-list',
    props: {
      images: {
        type: [Array, Boolean],
        required: true
      },
      post: Object
    },
    computed: {
      hideWhileActive () {
        if (this.$store.state.imageZoomActive) {
          return 'sm-hide'
        }
        return
      }
    },
    methods: {
      imageLink (idx) {
        return `#${idx}`
      }
    },
    components: { Gallery }
  }
</script>



// WEBPACK FOOTER //
// src/components/partials/ImageList.vue